module.exports = __webpack_public_path__ + "img/basketball.f5210fb7.svg";